




























import { Component, Vue, PropSync } from 'vue-property-decorator';
import { directive } from 'vue-awesome-swiper';

@Component({
  directives: {
    swiper: directive,
  },
})
export default class HomeStockSection extends Vue {}
